import { createGlobalStyle } from "styled-components";
import essentialsStyles from "@ritual/essentials-for-web/dist/stencil-library/stencil-library.css";

const GlobalStyle = createGlobalStyle`${typeof essentialsStyles === "string" ? essentialsStyles : (essentialsStyles?.default ?? "")}`;

export default GlobalStyle;
